import { $api_online } from "./api";

export class OnlineService {
  static getAttacking(matchId: number) {
    return $api_online.get(`/online/attacking/${matchId}`);
  }

  static getReferee(matchId: number) {
    return $api_online.get(`/online/referee/${matchId}`);
  }
}
